<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content" style="font-size: 12px">
    <div class="modal-header">
      <h4 class="modal-title">{{ model.title }}</h4>
      <aurora-icon-button class="close" type="button" (click)="action('close')" icon="times" size="large"></aurora-icon-button>
    </div>
    <ng-container *ngIf="ds.loadingCount > 0">
      <div class="ep-pageloadingindicator">
        <i class="fa fa-pulse fa-ep-loading fa-4x"></i>
      </div>
      <div class="ep-dialogprocessingoverlay"></div>
    </ng-container>
    <div class="modal-body">
      <!--Model {{ model | json }}-->
      <dataservice-error></dataservice-error>

      <ng-content></ng-content>
    </div>
    <div class="modal-footer">
      <aurora-button *ngIf="model.currentOptions.allowMultiSelect" type="button" (click)="action('select')" variant="primary">
        Select
      </aurora-button>
      <aurora-button
        *ngIf="model.currentOptions.allowClear"
        type="button"
        (click)="action('clear')"
        [variant]="model.currentOptions.allowMultiSelect ? 'secondary' : 'primary'"
      >
        Clear
      </aurora-button>
      <aurora-button
        type="button"
        (click)="action('cancel')"
        [variant]="!model.currentOptions.allowMultiSelect && !model.currentOptions.allowClear ? 'primary' : 'ghost'"
      >Cancel</aurora-button>
    </div>
    <dataservice-debug *ngIf="app.Settings.Debug.ShowPageDataService"></dataservice-debug>
  </div>
</div>
